module.exports = __webpack_public_path__ + "img/carrefour_rimouski.6c2d4383.webp";